import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const createWebWidget = (data) =>
  axios({
    url: config.endpoints.configurations.aocs,
    method: 'post',
    data,
    headers: getHeaders(true),
  })

const getAllWebWidget = () =>
  axios({
    url: config.endpoints.configurations.aocs,
    method: 'get',
    headers: getHeaders(true),
  })

const getByIdWebWidget = (id) =>
  axios({
    url: config.endpoints.configurations.aocs + '/' + id,
    method: 'get',
    headers: getHeaders(true),
  })

const updateWebWidget = (id, data) =>
  axios({
    url: config.endpoints.configurations.aocs + '/' + id,
    method: 'put',
    data,
    headers: getHeaders(true),
  })

const removeWebWidget = (id) =>
  axios({
    url: config.endpoints.configurations.aocs + '/' + id,
    method: 'delete',
    headers: getHeaders(true),
  })

const createQRPoster = (data) =>
  axios({
    url: config.endpoints.configurations.qrPoster,
    method: 'post',
    data,
    headers: getHeaders(true),
  })

const getAllQRPoster = () =>
  axios({
    url: config.endpoints.configurations.qrPoster,
    method: 'get',
    headers: getHeaders(true),
  })

const removeQRPoster = (id) =>
  axios({
    url: config.endpoints.configurations.qrPoster + '/' + id,
    method: 'delete',
    headers: getHeaders(true),
  })

const getByIdQRPoster = (id) =>
  axios({
    url: config.endpoints.configurations.qrPoster + '/' + id,
    method: 'get',
    headers: getHeaders(true),
  })

const updateQRPoster = (id, data) =>
  axios({
    url: config.endpoints.configurations.qrPoster + '/' + id,
    method: 'put',
    data,
    headers: getHeaders(true),
  })

export default {
  createWebWidget,
  getAllWebWidget,
  getByIdWebWidget,
  updateWebWidget,
  removeWebWidget,
  createQRPoster,
  getAllQRPoster,
  removeQRPoster,
  getByIdQRPoster,
  updateQRPoster
}